import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed, set } from '@ember/object';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';

interface SettingsReportsTablesCellsTdNbOfRecipientsSignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdNbOfRecipients extends Component<SettingsReportsTablesCellsTdNbOfRecipientsSignature> {
  isHovered = false;

  @computed('reports.@each.recipient')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get nbOfRecipients() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.reports?.length;
  }

  @computed('args.cellData.reports')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reports() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.cellData?.reports;
  }

  @action
  // @ts-expect-error: Incorrect type
  isCellHovered(isHovered): void {
    set(this, 'isHovered', isHovered);
  }

  <template>
    {{! template-lint-disable table-groups }}
    <div
      role="tooltip"
      {{on "mouseenter" (fn this.isCellHovered true)}}
      {{on "mouseleave" (fn this.isCellHovered false)}}
    >
      {{this.nbOfRecipients}}
    </div>
    {{#if this.isHovered}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @side="left"
        @tooltipClass="settings-reports-recipients-tooltip default-tooltip default-tooltip--large"
      >
        <table class="settings-reports-tooltips-table">
          {{#each this.reports as |report|}}
            <tr class="settings-reports-tooltips-table-row">
              <td>
                {{report.receiver.email}}
              </td>
            </tr>
          {{/each}}
        </table>
      </EmberTooltip>
    {{/if}}
  </template>
}
